import { SyntheticEvent, useContext, FC } from "react";
// Libraries
// @ts-ignore
import { IntercomAPI } from "react-intercom";
// API
import { clearApolloStorage } from "api/graphQL";
// Utils
import { AppContext } from "config/appProvider";
import { CommonContext } from "config/commonProvider";
import { SETTINGS, USER_SETTINGS } from "constants/Routes";
import { clearLocalStorage } from "helpers/storage";
// Containers
import { DashboardAvatarButton } from "containers/dashboard";
// Components
import { DropdownMenu } from "components";

export const DashboardUser: FC = () => {
  const { changeMainAppState } = useContext(AppContext);
  const { resetMainCommonState } = useContext(CommonContext);

  const logout = (event: SyntheticEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    IntercomAPI("shutdown");
    clearLocalStorage();
    // @ts-ignore
    changeMainAppState({});
    resetMainCommonState();
    clearApolloStorage();
  };

  const settingsURL = `${SETTINGS}${USER_SETTINGS}`;

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <DashboardAvatarButton />
      </DropdownMenu.Trigger>

      <DropdownMenu.Content>
        <DropdownMenu.Link text="Settings" to={settingsURL} />
        <DropdownMenu.Separator />
        <DropdownMenu.Action onClick={logout} text="Logout" />
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
